import React from "react";
import { COMMONS } from "../calendar/commons";
import { getMorningAndEveningCelebrations } from "../calendar/ordinariate-calendar";
import { CalendarDay } from "../calendar/utils";
import { useDataDependency } from "../utils/RemoteDataProvider";
import { CalCheckSection } from "./CalCheckSection";
import { ZEB } from "./zeb";

const scanForAntiphons = (texts: string[]) => {
    const rows = ["ID (DO NOT CHANGE)\tLABEL\tANTIPHON TEXT"];

    const alreadyFound: { [id: string]: boolean } = {};

    const zebAnts: { [id: string]: string } = {};

    ZEB.split("\n").forEach((row) => {
        const parts = row.split("\t");

        zebAnts[parts[0]] = parts[2];
    });

    const maybeAddText = (
        id: string | undefined,
        label: string,
        isEastertide: boolean
    ) => {
        if (id === undefined) {
            return;
        }

        if (isEastertide) {
            const easterId = `${id} [easter]`;

            const existingValueWithAllelluia = zebAnts[easterId] ?? "MISSING";

            if (!alreadyFound[easterId]) {
                rows.push(
                    `${easterId}\t${label} with Alleluia\t${existingValueWithAllelluia}`
                );
                alreadyFound[easterId] = true;
            }
        } else {
            const existingValue = zebAnts[id] ?? "MISSING";

            if (!alreadyFound[id]) {
                rows.push(`${id}\t${label}\t${existingValue}`);
                alreadyFound[id] = true;
            }
        }
    };

    const regionLabels =
        localStorage.getItem("region-switches")?.split(";;;") ?? [];

    for (let year = 2000; year < 2100; year++) {
        const days = getMorningAndEveningCelebrations(
            year,
            false,
            false,
            false,
            regionLabels
        ).concat(
            getMorningAndEveningCelebrations(
                year,
                true,
                true,
                true,
                regionLabels
            )
        );

        days.forEach((day) => {
            const celebrationList = day.morningOptions.concat(
                day.morningOutranked
            );

            const isEastertide =
                celebrationList?.find(
                    (celebration) =>
                        (celebration.title.includes("Easter") ||
                            celebration.title.includes("Ascension") ||
                            celebration.title === "Rogation Monday" ||
                            celebration.title === "Rogation Tuesday" ||
                            celebration.title === "Rogation Wednesday" ||
                            celebration.title === "Rogation Thursday" ||
                            celebration.title === "Rogation Friday" ||
                            celebration.title === "Rogation Saturday" ||
                            celebration.title.includes("Whit") ||
                            celebration.title.includes("Pentecost")) &&
                        celebration.title !== "Trinity Sunday"
                ) !== undefined;

            celebrationList.forEach((celebration) => {
                maybeAddText(
                    celebration.ep1MagId,
                    `${celebration.title} Mag at EP1`,
                    isEastertide
                );
                maybeAddText(
                    celebration.invId,
                    `${celebration.title} Inv`,
                    isEastertide
                );
                maybeAddText(
                    celebration.mpBenId,
                    `${celebration.title} Ben`,
                    isEastertide
                );
                maybeAddText(
                    celebration.ep2MagId,
                    `${celebration.title} Mag at EP2`,
                    isEastertide
                );

                celebration.commons?.forEach((common) => {
                    maybeAddText(
                        COMMONS[common].ep1MagId,
                        `Common of ${common} Mag at EP1`,
                        isEastertide
                    );
                    maybeAddText(
                        COMMONS[common].invId,
                        `Common of ${common} Inv`,
                        isEastertide
                    );
                    maybeAddText(
                        COMMONS[common].mpBenId,
                        `Common of ${common} Ben`,
                        isEastertide
                    );
                    maybeAddText(
                        COMMONS[common].ep2MagId,
                        `Common of ${common} Mag at EP2`,
                        isEastertide
                    );
                });
            });
        });
    }

    return rows.join("\n");
};

export const CalCheck: React.FC<{}> = () => {
    const year = new Date().getFullYear();

    const regionLabels =
        localStorage.getItem("region-switches")?.split(";;;") ?? [];

    const days = getMorningAndEveningCelebrations(
        year,
        false,
        false,
        false,
        regionLabels
    );

    const loadableTextList = useDataDependency<string[]>({
        type: "ord text list",
    });

    console.log(loadableTextList);

    const todayIndex = days.findIndex(
        (day) =>
            day.date === new Date().getDate() &&
            day.month === new Date().getMonth() + 1 &&
            day.year === new Date().getFullYear()
    );

    if (loadableTextList.state === "loaded") {
        console.log();
    }

    return (
        <div style={{ height: "100%", overflow: "scroll", padding: 24 }}>
            <textarea>
                {scanForAntiphons(
                    loadableTextList.state === "loaded"
                        ? loadableTextList.value
                        : []
                )}
            </textarea>
            {days.slice(todayIndex, todayIndex + 42).map((day) => {
                const calendarDay: CalendarDay = {
                    year,
                    month: day.month,
                    date: day.date,
                    dayOfTheWeek: "mon",
                    label: "",
                    collect: "",
                    collectId: "",
                    otherLabels: [],
                    dayOfTheYear: 0,
                    weekOfTheYear: 0,
                    antiphonId: "",
                    sentenceId: "",
                    hymnId: "",
                    // any eastertide day
                    easterOctave:
                        day.morningOptions
                            .concat(day.morningOutranked)
                            .find(
                                (option) =>
                                    option.title.includes("Easter") ||
                                    option.title.includes("Ascension") ||
                                    option.title.includes("Whit") ||
                                    option.title.includes("Pentecost")
                            ) !== undefined,
                };

                return (
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            borderBottom: "1px solid #DDD",
                            paddingTop: 8,
                            paddingBottom: 8,
                            backgroundColor:
                                day.day === "sun" ? "#F0F0F0" : undefined,
                        }}
                    >
                        <div style={{ width: 50 }}>
                            {day.month}-{day.date}
                        </div>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                flexGrow: 1,
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    borderBottom: "1px solid #DDD",
                                }}
                            >
                                <div style={{ width: 50 }}>AM</div>
                                <CalCheckSection
                                    day={calendarDay}
                                    celebrations={day.morningOptions}
                                    outrankedCelebrations={day.morningOutranked}
                                    isFirstEvensong={[]}
                                    isMattins={true}
                                    loadableTextList={loadableTextList}
                                />
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    paddingTop: 8,
                                }}
                            >
                                <div style={{ width: 50 }}>PM</div>
                                <CalCheckSection
                                    day={calendarDay}
                                    celebrations={day.eveningOptions}
                                    outrankedCelebrations={day.eveningOutranked}
                                    isFirstEvensong={day.isFirstEvensong}
                                    isMattins={false}
                                    loadableTextList={loadableTextList}
                                />
                            </div>
                            {day.morningOptions
                                .concat(day.morningOutranked)
                                .find(
                                    (celebration) =>
                                        celebration.type === "feria" ||
                                        celebration.type === "sunday"
                                ) === undefined ? (
                                <div>❌ No feria</div>
                            ) : (
                                <></>
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};
